import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { BrandText } from './BrandText';
import { useCursor } from '../context/CursorContext';
import { navLinks } from '../data/mock';

export const Navigation = () => {
  const location = useLocation();
  const { setLabel } = useCursor();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-full bg-black/70 backdrop-blur-lg border border-white/10 px-6 py-3 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3"
            onMouseEnter={() => setLabel('Home')}
            onMouseLeave={() => setLabel('')}
          >
            <Logo size="sm" />
            <BrandText className="text-sm hidden sm:inline" />
          </Link>

          <div className="hidden md:flex gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-black bg-green-500'
                    : 'text-white/60 hover:text-white hover:bg-white/10'
                }`}
                onMouseEnter={() => setLabel(link.label)}
                onMouseLeave={() => setLabel('')}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="md:hidden text-white/60 hover:text-white transition-colors duration-300"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden mt-2 bg-black/90 backdrop-blur-lg border border-white/10 rounded-2xl p-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-xl text-xs font-semibold uppercase tracking-wider transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-black bg-green-500'
                    : 'text-white/60 hover:text-white hover:bg-white/5'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};
